import { Component, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogModule, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../../../environments/environment';
import { DataService } from '@app/service/data.service';
import { combineLatest } from 'rxjs';
import { Utilities } from '@app/class/utilities';
import { TranslatePipe } from "@ngx-translate/core";
import { WhatsappService } from '@app/service/whatsapp.service';

@Component({
  selector: 'app-infocar-limit',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    MatButtonModule
  ],
  templateUrl: './infocar-limit.component.html',
  styleUrl: './infocar-limit.component.scss'
})
export class InfocarLimitComponent implements OnInit {
  isMakena = environment.makena;
  predefinedMessage = "";

  constructor(
    private dialogRef: MatDialogRef<InfocarLimitComponent>,
    private _dataService: DataService,
    private _translateService: TranslateService,
    private _whatsappService: WhatsappService
  ) { }

  ngOnInit() {
    const translatePipe = new TranslatePipe(this._translateService, null as any);
    combineLatest([
      this._dataService.user$,
      this._dataService.company$
    ]).subscribe(([userData, companyData]) => {
      const saudation = translatePipe.transform(Utilities.getSaudation());

      this.predefinedMessage = `${saudation}, sou ${userData.name} da empresa ${companyData.fancyName} (CNPJ: ${companyData.cnpj}).\nAs minhas consultas de placas foram esgotadas. Gostaria de receber informações sobre os planos disponíveis para contratação de mais consultas.`;
    });
  }

  onClickWhatsApp(){
    this._whatsappService.openWhatsCs(this.predefinedMessage);
  }

  close(){
    this.dialogRef.close()
  }

}
